import React, { useContext } from 'react'
import { useWindowWidth } from '@react-hook/window-size'
import CrossSellProducts from 'client/common/components/crossSell/CrossSellProducts'
import { TranslateContext } from 'client/common/translator'
import { getProductCards } from 'client/common/components/Products'
import { isLoading } from 'client/common/components/crossSell/List'
import ProductsPlaceholdersList from 'client/common/components/ProductsPlaceholdersList'
import ScrollCarousel from 'client/common/components/slider/ScrollCarousel'
import classNames from 'classnames'
import { Chip } from 'client/common/components/chip/Chip'
import { Divider } from 'client/common/components/Divider'
import { Text } from 'chemistry'

export const View = props => {
  const width = useWindowWidth()
  const {
    lang,
    format,
    loading,
    error,
    data,
    titleKey,
    onProductClick,
    rootClassName,
    isContainerless,
    showSoldByProductCards,
    showAvailabilityStatusMultiple
  } = props
  const t = useContext(TranslateContext)

  if (error) return null

  const collection = data?.products?.collection

  if (width > 768 && collection?.length >= 5) {
    if (isLoading(loading, collection)) return <ProductsPlaceholdersList count={5} perRow={5} />
    if (!collection) return null
    const cardClassName = 'mxd-width-1-1 mxd-small-width-1-1'
    const cards = getProductCards({
      collection,
      t,
      lang,
      format,
      sizes: ['sm', 'md'],
      cardClassName,
      onProductClick,
      showSoldByProductCards,
      showAvailabilityStatusMultiple
    })
    return (
      <div id={isContainerless ? '' : 'lastViewedProducts'}>
        <div className={classNames('mxd-cross-sell-block', rootClassName)}>
          <Divider />
          <div className='flex items-center gap-1'>
            <Text fontSize='2xl' fontFamily='bold'>
              {t(titleKey)}
            </Text>
            <Chip text={collection.length} />
          </div>
          <ScrollCarousel items={cards} options={{ showProgress: true }} />
        </div>
      </div>
    )
  }

  const titleElem = collection?.length > 0 ? <Chip text={collection.length} /> : null
  return <CrossSellProducts {...{ ...props, titleElem, count: 4 }} />
}
